import { MessageBox, Tabs } from '@infotech-soe/erp-ui-kit';
import { DSAgents } from '@infotech-soe/mia-ds-service/types';
import classNames from 'classnames';
import React, { JSX } from 'react';
import { useIntl } from 'react-intl';

import { DSLoginFormContainerProps } from '../session/AuthFormContainer';

import DSAgentForm from './DSAgentForm';
import { signFormMessages } from './messages';
import { SignFormContainerProps } from './SignFormContainer';

export const SignForm = ({
  allowedDSMediaTypes,
  className,
  dsAgents,
  dsKeyTypes,
  forbiddenDSMediaTypes,
  open,
  signAlgo,
  signData = [''],
  signatureType = 'detached',
  onClose,
  onError,
  onSign,
}: SignFormContainerProps): JSX.Element => {
  const { formatMessage } = useIntl();

  const commonDSFormProps: Omit<DSLoginFormContainerProps, 'dsAgent'> = {
    allowedDSMediaTypes,
    applications: undefined,
    dsKeyTypes,
    forbiddenDSMediaTypes,
    hasError: undefined,
    signAlgo,
    signatureType,
    signData,
    submitLabel: undefined,
    withApplications: false,
    withTitle: false,
    onError,
    onSubmit: onSign,
  };

  const withCipherTab = dsAgents.includes(DSAgents.CIPHER);
  const withIITTab = dsAgents.includes(DSAgents.IIT);

  return (
    <MessageBox
      height="auto"
      noCloseButton={false}
      open={open}
      title={formatMessage(signFormMessages.title)}
      onClose={() => onClose(false)}
    >
      <MessageBox.Content className={classNames('m-pa-md', className)}>
        <Tabs>
          <Tabs.Pane name={DSAgents.IIT} hidden={!withIITTab}>
            {withIITTab && (
              <DSAgentForm dsAgent={DSAgents.IIT} {...commonDSFormProps} />
            )}
          </Tabs.Pane>
          <Tabs.Pane name={DSAgents.CIPHER} hidden={!withCipherTab}>
            {withCipherTab && (
              <DSAgentForm dsAgent={DSAgents.CIPHER} {...commonDSFormProps} />
            )}
          </Tabs.Pane>
        </Tabs>
      </MessageBox.Content>
    </MessageBox>
  );
};
